<template>
	<div class="border-top">
		<SOFilterTitle :title="getTitle" :diterapkan="diterapkan" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
			<SOFilterCheckboxSkeleton v-if="pageSetting.loading"/>
			<!--<SOInputCheckbox-->
			<!--	:checkboxes="checkboxPaketDeposit"-->
			<!--	:checked="filterItem.deposit"-->
			<!--	:limit-loop="true"-->
			<!--	:limit-loop-count="4"-->
			<!--	:use-check-all="useCheckAll"-->
			<!--	:modal-id="'more-paket-deposit'"-->
			<!--	:modal-title="title"-->
			<!--	@selected="selected"-->
			<!--/>-->
			<SOInputSelectMultiple
				v-if="!pageSetting.loading"
				:title="'Pilih paket deposit'"
				:label="'title'"
				:placeholder="'Pilih paket deposit'"
				:track-by="'title'"
				:options="checkboxPaketDeposit.data"
				:multiple="true"
				:searchable="true"
				:value="checkedCheckboxPaketDeposit"
				@selected="selected"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOFilterCheckboxSkeleton from "@/so-components/global/filter/skeleton/SOFilterCheckboxSkeleton";
// import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";
import SOInputSelectMultiple from "@/so-components/global/input/SOInputSelectMultiple";

export default {
	name: "SOFilterPaketDeposit",
	components: {
		SOFilterTitle,
		SOFilterCheckboxSkeleton,
		// SOInputCheckbox,
		SOInputSelectMultiple,
	},
	props: {
		id: String,
		title: {
			type: String,
			default: "Top Up Paket"
		},
		useCheckAll: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		}),
		...mapGetters("depositModule", {
			paketDeposits: "getListPaketDepositOwner",
		}),
		getTitle() {
			return this.title;
		}
	},
	data() {
		return {
			checkboxPaketDeposit: {
				name: "paket-deposit",
				data: []
			},
			checkedCheckboxPaketDeposit: [],
			pageSetting: {
				loading: true,
			},
			diterapkan: false
		}
	},
	mounted() {
		this.getPaketDeposit()
		this.diterapkan = this.filterItem.deposit.length > 0
	},
	watch: {
		"filterItem.outlet": {
			handler: function () {
				this.getPaketDeposit()
				this.diterapkan = this.filterItem.deposit.length > 0
			},
			deep: true,
			immediate: true
		},
	},
	methods: {
		async getPaketDeposit() {
			this.pageSetting.loading = true
			// const res = await this.$store.dispatch("depositModule/fetchListPaketDepositOwnerAll")
			const res = await this.$store.dispatch("depositModule/fetchListPaketDepositOwnerAll", this.filterItem.outlet)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.checkboxPaketDeposit.data = []
			this.checkedCheckboxPaketDeposit = []
			this.paketDeposits.data.forEach((item) => {
				// SOInputCheckbox
				// this.checkboxPaketDeposit.data = [...this.checkboxPaketDeposit.data, {
				// 	id: "fpdps-" + item.data_deposit_iddata_deposit,
				// 	value: item.data_deposit_iddata_deposit,
				// 	title: item.Deposit.nama + " <div class='f-12 f-c-black'>(Outlet " + item.outlet.nama + " )</div>",
				// 	checked: false,
				// 	titleBold: false,
				// }]

        // SOInputSelectMultiple
        this.checkboxPaketDeposit.data = [
          ...this.checkboxPaketDeposit.data,
          {
            id: "fpdps-" + item.iddeposit,
            value: item.iddeposit,
            title: item.nama_deposit,
            subtitle: "Outlet " + item.nama_outlet,
          },
        ];
      });
      this.setSelectedData();
    },
    setSelectedData() {
      if (this.filterItem.deposit.length > 0) {
        this.checkboxPaketDeposit.data.forEach((v) => {
          this.filterItem.deposit.forEach((vv) => {
            if (v.value === vv) {
              this.checkedCheckboxPaketDeposit = [...this.checkedCheckboxPaketDeposit, v];
            }
          });
        });
      }
    },
    selected(val) {
      // SOInputCheckbox
      // let selected = [];
      // if (typeof val === "string") {
      // 	if (val === "checkAll") {
      // 		this.paketDeposits.data.forEach(item => {
      // 			selected.push(item.data_deposit_iddata_deposit);
      // 		});
      // 	} else {
      // 		selected = [];
      // 	}
      // } else {
      // 	selected = val;
      // }

      // SOInputSelectMultiple
      console.log(val);
      let selected = [];
      val.forEach((v) => {
        selected = [...selected, v.value];
      });

      let temp = this.filterItem;
      temp.deposit = selected;
      this.$store.commit("filterGlobalModule/setFilterItem", temp);
      this.diterapkan = this.filterItem.deposit.length > 0;
    },
  },
};
</script>
